<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" v-if="showBtn">
            <div class="left">
                <button @click="doAddPayPre();" class='swb-btn swb-btn-small mt5 mb10' v-if="!selectPrftCenterCode && filter.lockMode != -1">
                    <span>新增</span>
                </button>
                <button @click="toSelectPrftCenterCode(null);" class='swb-btn swb-btn-small mt5 mb10' v-if="checkBox && selectPrftCenterCode && dataList.length > 0">
                    <span>选择利润中心</span>
                </button>
            </div>
            <div class="right"></div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'
    import { showPayPreInfoDlg, loadSettleBizSrcPrftCenterCodeList, selectPrftCenterCodeLis, showBankAccInfoDlg } from '../settle/showDlg'
    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { openPageRouteUrl } from '../../../src/app.conf'

    import finacApi from '../../api/finac'
    import userApi from '../../api/user'

    //
    import SwbPayVoucherInfo from '../payment/PayVoucherInfo';
    Vue.regist(SwbPayVoucherInfo);

    export default {
        name: 'swb-pay-voucher-list-for-select',
        desc: '预付款单选择列表',
        props: {
            showBtn: { // 展示新增操作按钮
                type: Boolean,
                default: false
            },
            selectPrftCenterCode: { // 展示选择利润中心按钮，默认不显示
                type: Boolean,
                default: false
            },
            payPreFilter: { // 当showBtn = true 的时候有效
                type: Object,
                default: function () {
                    return {};
                }
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            settleProofId: { // 结算单id
                type: Number,
                default: null
            },
            prftCenterCode: { // 结算单中的利润中心
                type: String,
                default: null
            },
            parentSelf: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            parentPath: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-pay-voucher-list-for-select',
                theTableHeight: 600,
                //
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                prftCenterCodeList: [],
                dataList: [],
                resultStateMap: getEnumMap('resultState', 'value2text'),
                payWayMap: getEnumMap("payWay", "value2text"),
                refresh: false,
                postId: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.multiSelect = Utils.isTrue(this.checkBox);
            this.multiPageSelect = Utils.isTrue(this.checkBox);
            if(!Utils.isTrue(this.checkBox)) {
                this.rowNoShow = true;
                this.rowNoFixed = true;
            }
            if(Utils.isTrue(this.showBtn)) {
                this.btnColName = 'actions';
            }
            //
            let self = this;
            if(!Utils.isNoB(self.settleProofId) && self.settleProofId != -1) {
                loadSettleBizSrcPrftCenterCodeList(self.settleProofId, function (dataList) {
                    self.prftCenterCodeList = Utils.merge([], dataList);
                });
            }
            //
            this.getCurrUserInfo();
        },
        mounted() {
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            //
            this.initResultTable();
            this.handleInitChecked();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.postId = scopeEntity.postId;
                    }
                });
            },
            onQueryConfigReady: function () {
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    // 交易状态
                    'payResult': function (row, colName, colValue, rowIndex, colConf) {
                        //
                        let resultStateInfo = getEnumInfoWith('resultState', 'value', row.payResult);
                        if(resultStateInfo != null) {
                            if(resultStateInfo.name == "Failure") {
                                row.payResultText = "支付失败";
                            } else if(resultStateInfo.name == "Success") {
                                row.payResultText = "支付成功";
                            } else {
                                if(row.discarded && !row.deleted) {
                                    row.payResultText = "拒绝付款";
                                } else {
                                    row.payResultText = "待支付";
                                }
                            }
                        }
                        return '<span>' + (row.payResultText || self.resultStateMap[row.payResult]) + '</span>';
                    },
                    'payWay': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.payWayMap[row.payWay] + '</span>';
                    },
                    'tradeNo': function (row, colName, colValue, rowIndex) {
                        if(!Utils.isNoB(row.tradeNo)) {
                            return '<a ref="#" class="table-cell-link">' + row.tradeNo + '</a>'
                        } else {
                            return Utils.isNoB(row.tradeNo) ? '' : row.tradeNo;
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if(row.auditState == 0 && row.applyState != 1 && (row.creatorPostId == self.postId || row.creatorPostId == null) && !Utils.isTrue(self.selectPrftCenterCode)) {
                            btnList.push({
                                name: 'assign_auditor',
                                text: '指定审核岗'
                            });
                        }
                        if(row.applyState == 1 && row.auditState != 1 && !row.discarded && row.auditorPostId == self.postId && !Utils.isTrue(self.selectPrftCenterCode)) {
                            btnList.push({
                                name: 'audit',
                                text: '审核'
                            });
                        }
                        if(!row.discarded && row.payResult != 1) {
                            btnList.push({
                                name: 'update_bankAccInfo',
                                text: '补充银行卡'
                            });
                        }
                        // selectPrftCenterCode 为true 说明显示选择利润中心按钮
                        if(Utils.isTrue(self.selectPrftCenterCode)) {
                            if(Utils.isNoB(row.prftCenterCode)) {
                                btnList.push({
                                    name: 'select_prftCenterCode',
                                    text: '选择利润中心'
                                });
                            } else {
                                btnList.push({
                                    name: 'remove_prftCenterCode',
                                    text: row.prftCenterCode + ' - 移除'
                                });
                            }
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'assign_auditor') {
                            // 指定审核岗
                            self.assignAuditor(row);
                        } else if(btnName == 'audit') {
                            // 审核
                            self.doCheck(row.id);
                        } else if(btnName == 'select_prftCenterCode') {
                            self.toSelectPrftCenterCode(row);
                        } else if(btnName == 'remove_prftCenterCode') {
                            self.removePrftCenterCode(row);
                        } else if(btnName == 'update_bankAccInfo') {
                            self.editBankAccInfo(row);
                        }
                    }
                });
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                let selectRows = resultTable.getSelection();
                if(Utils.isTrue(this.checkBox)) {
                    selectRows = selectRows || [];
                    this.selectIds = Utils.merge([], selectRows.pluck("id") || []);
                } else {
                    if(!Utils.isNoB(selectRows) && selectRows.id > 0) {
                        let selectIds = this.selectIds || [];
                        if(!selectIds.contains(selectRows.id)) {
                            selectIds.push(selectRows.id);
                        } else {
                            selectIds.remove(selectRows.id);
                        }
                        this.selectIds = Utils.merge([], selectIds);
                    }
                }
                return selectRows;
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getDataList();
            },
            //
            handleClick(tab, event) {
                this.pageNoChangeHandler(1, this.pageSize);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems = Object.assign(filterItems, self.filter);
                //
                filterItems.prePayFlag = true;
                filterItems.directFlag = getEnumInfoWith('directFlag', 'name', 'Forward').value;
                filterItems.amountAvailable = true;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                finacApi.getPayVoucherList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let dataList = result.data.rows || [];
                        if(Utils.isTrue(self.selectPrftCenterCode)) {
                            for(let i = 0; i < dataList.length; i++) {
                                let dataInfo = dataList[i];
                                if(!Utils.isNoB(self.prftCenterCode)) {
                                    dataInfo.prftCenterCode = self.prftCenterCode;
                                } else {
                                    dataInfo.prftCenterCode = null;
                                }
                            }
                        }
                        self.dataList = Utils.merge([], dataList);
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.dataList, result.data.pagination);
                        self.handleInitChecked();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //回显数据处理
            handleInitChecked() {
                let initChecked = this.selectIds || [];
                let resultTable = this.$refs.result_table;
                resultTable.setInitChecked(initChecked, false);
            },
            // 补充银行卡信息
            editBankAccInfo: function (row) {
                let self = this;
                showBankAccInfoDlg(row, function (bankAccInfo, theDlg) {
                    bankAccInfo.id = row.id;
                    let hintMsg = bankAccInfo.hintMsg;
                    if(!Utils.isNoB(hintMsg)) {
                        self.$confirm(hintMsg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            //
                            let msgBoxDlg = MsgBox.loading();
                            finacApi.updatePayVoucherBankAccInfo(bankAccInfo, function (result) {
                                msgBoxDlg.close();
                                if(result.type == 'info') {
                                    theDlg.close();
                                    self.getDataList();
                                    MsgBox.success("操作成功");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }).catch(function () {
                        });
                    } else {
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.updatePayVoucherBankAccInfo(bankAccInfo, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                theDlg.close();
                                self.getDataList();
                                MsgBox.success("操作成功");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 指定审核人
            assignAuditor: function (row) {
                let self = this;
                //
                showComActionPostSelectDlg({
                    title: '指定审核岗',
                    rescUrl: self.parentPath,
                    action: 'pre_pay',
                    initPostId: row.auditorPostId,
                    applyDesc: row.applyDesc
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: row.id,
                        //
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.actionPostName,
                        //
                        applyDesc: resultData.applyDesc
                    };
                    //
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.assignPayVoucherAuditorInfo(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            self.getDataList();
                            MsgBox.success("操作成功");
                        } else {
                            MsgBox.warning("操作失败");
                        }
                    });

                }, this);
            },
            // 审核操作
            doCheck: function (payVoucherId) {
                let self = this;
                Vue.$showDialog({
                    title: '支付单据 - 审核',
                    showCloseBtn: true,
                    width: 900,
                    height: 800,
                    template: '<div>' +
                    '<swb-pay-voucher-info :voucherId="voucherId" :optionFlag="optionFlag" ref="swb_pay_voucher_info"></swb-pay-voucher-info>' +
                    '</div>',
                    data: {
                        voucherId: null,
                        optionFlag: 'shenHe'
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_pay_voucher_info.getDlgResult() || {};
                        // 成功执行
                        if(result.type == 'info') {
                            // 处理你的信息添加赋值
                            let postData = result.data;
                            //
                            let msgBoxDlg = MsgBox.loading();
                            finacApi.auditPayVoucher(postData, function (result) {
                                msgBoxDlg.close();
                                if(result.type == 'info') {
                                    self.getDataList();
                                    MsgBox.success("操作成功");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            this.voucherId = payVoucherId;
                        }
                    }
                })
            },
            // 预付功能
            doAddPayPre(){
                let self = this;
                let payPreFilter = self.payPreFilter || {};
                let params = {
                    contractId: payPreFilter.contractId,
                    contractNo: payPreFilter.contractNo,
                    payPhaseTplId: payPreFilter.payPhaseTplId,
                    orderType: payPreFilter.orderType,
                    orderId: payPreFilter.orderId,
                    orderNo: payPreFilter.orderNo,
                    sellerRealComId: payPreFilter.sellerRealComId,
                    buyerRealComId: payPreFilter.buyerRealComId,
                    amount: payPreFilter.amount
                };
                showPayPreInfoDlg(params, function (payPreInfo, theDlg) {
                    let hintMsg = payPreInfo.hintMsg;
                    if(!Utils.isNoB(hintMsg)) {
                        self.$confirm(hintMsg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            //
                            let msgBoxDlg = MsgBox.loading();
                            finacApi.savePrePayVoucher(payPreInfo, function (result) {
                                msgBoxDlg.hide();
                                if(result.type === "info") {
                                    self.getDataList();
                                    MsgBox.success('操作成功!');
                                    theDlg.close();
                                    self.refresh = true;
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }).catch(function () {
                        });
                    } else {
                        //
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.savePrePayVoucher(payPreInfo, function (result) {
                            msgBoxDlg.hide();
                            if(result.type === "info") {
                                self.getDataList();
                                MsgBox.success('操作成功!');
                                theDlg.close();
                                self.refresh = true;
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 选择利润中心
            toSelectPrftCenterCode: function (row) {
                let self = this;
                if(Utils.isNoB(row)) {
                    let selectRows = this.getTableSelection() || [];
                    if(selectRows.length <= 0) {
                        MsgBox.warning("请选择预付单");
                        return;
                    }
                }
                selectPrftCenterCodeList(self.settleProofId, function (prftCenterCode) {
                    if(Utils.isNoB(row)) {
                        let selectRows = self.getTableSelection() || [];
                        if(selectRows.length > 0) {
                            let rowMap = selectRows.toMap("id");
                            let dataList = self.dataList || [];
                            for(let i = 0; i < dataList.length; i++) {
                                let dataInfo = dataList[i];
                                let selectRow = rowMap[dataInfo.id];
                                if(selectRow != null && selectRow.id == dataInfo.id) {
                                    dataInfo.prftCenterCode = prftCenterCode;
                                }
                            }
                            self.dataList = Utils.merge([], dataList);
                            let pagination = {
                                totalCount: self.totalCount
                            };
                            self.renderTable(self.dataList, pagination);
                            self.handleInitChecked();
                        }
                    } else {
                        let dataList = self.dataList || [];
                        for(let i = 0; i < dataList.length; i++) {
                            let dataInfo = dataList[i];
                            if(row.id == dataInfo.id) {
                                dataInfo.prftCenterCode = prftCenterCode;
                            }
                        }
                        self.dataList = Utils.merge([], dataList);
                        let pagination = {
                            totalCount: self.totalCount
                        };
                        self.renderTable(self.dataList, pagination);
                        self.handleInitChecked();
                    }
                });
            },
            // 移除利润中心
            removePrftCenterCode: function (row) {
                let dataList = this.dataList || [];
                for(let i = 0; i < dataList.length; i++) {
                    let dataInfo = dataList[i];
                    if(row.id == dataInfo.id) {
                        dataInfo.prftCenterCode = null;
                    }
                }
                this.dataList = Utils.merge([], dataList);
                let pagination = {
                    totalCount: this.totalCount
                };
                this.renderTable(this.dataList, pagination);
                this.handleInitChecked();
            },
            //
            getDlgResult: function () {
                let selectRows = this.getTableSelection() || [];
                let result = {};
                if(selectRows.length <= 0) {
                    result.type = 'warn';
                    result.message = '请选至少选择一个预付单！';
                } else {
                    let prftCenterCodeList = this.prftCenterCodeList || [];
                    if(Utils.isTrue(this.selectPrftCenterCode) && prftCenterCodeList.length > 0) {
                        let validatePass = true;
                        for(let i = 0; i < selectRows.length; i++) {
                            let selectRow = selectRows[i];
                            if(Utils.isNoB(selectRow.prftCenterCode)) {
                                validatePass = false;
                            }
                        }
                        if(Utils.isTrue(validatePass)) {
                            result.type = 'info';
                            result.data = selectRows;
                        } else {
                            result.type = 'warn';
                            result.message = '选择的预付单中有未选择利润中心的，请选择利润中心！';
                        }
                    } else {
                        result.type = 'info';
                        result.data = selectRows;
                    }
                }
                return result;
            },
            getRefreshResult: function () {
                let result = {};
                result.type = 'info';
                result.data = this.refresh;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payment/PayVoucherListForSelect.vue